/**
 *
 * @module events/group/extender
 * @author shojib [mahmud.hossain@mlb.com]
 * @description extended/custom events
 *
 */

/**
 *
 * @function eventGroup
 * @param {Object} master
 * @param {Object} model
 * @param {Object} viewModel
 *
 */
function eventGroup(scores = {}, scoresModel = {}, scoresViewModel = {}) {

    /**
     *
     * @event synthetic-data
     * @param {Object} data
     *
     */
    scores.on('synthetic-data', (data) => {

        scoresModel.emit('data', data);

    });

    /**
     *
     * @event load-date
     *
     */
    scores.on('load-date', (date) => {

        scoresViewModel.emit('clear');
        scoresModel.emit('load-date', date);

    });

    /**
     *
     * @event load-using-config for scores
     *
     */
    scores.on('load-using-config', (config) => {

        scoresViewModel.emit('clear');
        scoresModel.emit('load-using-config', config);

    });

    /**
     *
     * @event start
     *
     */
    scores.on('start', () => {

        scoresModel.emit('start');

    });

    /**
     *
     * @event scroll-to-date
     *
     */
    scores.on('scroll-to-date', (date) => {

        scoresViewModel.emit('scroll-to-date', date);

    });

    /**
     *
     * @event scroll-to-game
     *
     */
    scores.on('scroll-to-game', (gamePk) => {

        scoresViewModel.emit('scroll-to-game', gamePk);

    });

    /**
     *
     * @event stop
     *
     */
    scores.on('stop', () => {

        scoresModel.emit('stop');

    });

    /**
     *
     * @event clear-view-model
     *
     */
    scores.on('clear-view-model', () => {

        scoresViewModel.emit('clear');

    });

    /**
     *
     * @event data
     * @param {Object} data
     *
     */
    scoresModel.on('data', (data) => {

        scores.emit('data', data);
        scoresViewModel.emit('data', data);

    });

    /**
     *
     * @event data-error
     * @param {Object} data
     *
     */
    scoresModel.on('data-error', (err) => {

        scores.emit('data-error', err);
        scoresViewModel.emit('data-error', err);

    });

    /**
     *
     * @event start
     *
     */
    scoresModel.on('start', () => {

        scoresModel.start();

    });

    /**
     *
     * @event stop
     *
     */
    scoresModel.on('stop', () => {

        scoresModel.stop();

    });

    /**
     *
     * @event spinner
     *
     */
    scores.on('spinner', () => {

        scoresViewModel.spinner();

    });

    /**
     *
     * @event load-using-config for scoresModel
     *
     */
    scoresModel.on('load-using-config', (config) => {

        scoresModel.loadDate(config.date, config);

    });

    /**
     *
     * @event load-date
     *
     */
    scoresModel.on('load-date', (date) => {

        scoresModel.loadDate(date);

    });

    /**
     *
     * @event data
     * @param {Object} data
     *
     */
    scoresViewModel.on('data', (data) => {

        scoresViewModel.bind(data);

    });

    /**
     *
     * @event clear
     *
     */
    scoresViewModel.on('clear', () => {

        scoresViewModel.clear();

    });

    /**
     *
     * @event games-ready
     *
     */
    scoresViewModel.on('games-ready', (reference) => {

        scores.emit('games-ready', reference);

    });

    /**
     *
     * @event refresh ads
     *
     */
    scoresViewModel.on('refresh-ads', (adContainer) => {

        scores.emit('refresh-ads', adContainer);

    });

    /**
     *
     * @event scroll-to-game
     *
     */
    scoresViewModel.on('scroll-to-game', (gamePk) => {

        scoresViewModel.scrollToGame(gamePk);

    });

    /**
     *
     * @event scroll-to-game
     *
     */
    scoresViewModel.on('game-selected', (gamePk) => {

        scores.emit('game-selected', gamePk);

    });

    /**
     *
     * @event video completed playing
     *
     */
    scoresViewModel.on('video-completed', (gamePk) => {

        scoresViewModel.videoCompleted(gamePk);

    });

    /**
     *
     * @event video was paused
     *
     */
    scoresViewModel.on('video-paused', (gamePk) => {

        scoresViewModel.videoPaused(gamePk);

    });

    /**
     *
     * @event video started playing (was embedded)
     *
     */
    scoresViewModel.on('video-started', (gamePk) => {

        scoresViewModel.videoStarted(gamePk);

    });

    /**
     *
     * @event video was closed by clicking 'x' in top-right corner
     *
     */
    scoresViewModel.on('video-closed', (gamePk) => {

        scoresViewModel.videoClosed(gamePk);

    });

}

export default eventGroup;
